/*
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2023-11-27 11:09:58
 * @LastEditors: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @LastEditTime: 2024-05-30 10:15:39
 * @FilePath: /front-vps-admin/src/web-framework/api/settings.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const SettingsAPI = {
    /**
     * 获取所有系统非删除的设置
     * @returns 
     */
    search(categoryCode, withDatadic) {
        return Request.get(`/admin/settings/getSettings`, { categoryCode: categoryCode, withDatadic: withDatadic });
    },
    /**
     * @description: 批量保存修改后的系统设置
     * @param {*} settingArray
     * @return {*}
     */
    saveSystemSettings(settingArray) {
        return Request.post(`/admin/settings/saveSettings`, settingArray);
    },
    /**
     * @description: 获取某一个参数
     * @param {*} key
     * @return {*}
     */
    getSetting(key) {
        return Request.get(`/admin/settings/keys/${key}`);
    },
    /**
     * @description: 批量获取多个参数
     * @param {*} keys
     * @return {*}
     */
    getSettings(keys) {
        return Request.post(`/admin/settings/keys`, keys);
    }
};
export default SettingsAPI;